import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponLayer from "../../components/CoupanLayer";

const CouponPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Discount Coupon" />

        <CouponLayer />
      </MasterLayout>
    </>
  );
};

export default CouponPage;
